import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { LoaderCircle } from 'lucide-react'
import { useAuthStore } from '@/stores/auth-store'
import { useI18n } from '@/i18n/i18n'

function HydrationGate() {
  const { t } = useI18n()
  return <div className="grid min-h-screen place-items-center bg-canvas text-brand"><LoaderCircle className="size-7 animate-spin" /><span className="sr-only">{t('common.loading')}</span></div>
}

export function ProtectedRoute() {
  const { accessToken, hydrated } = useAuthStore()
  const location = useLocation()
  if (!hydrated) return <HydrationGate />
  return accessToken ? <Outlet /> : <Navigate to="/login" replace state={{ from: location.pathname }} />
}

export function PublicOnlyRoute() {
  const { accessToken, hydrated } = useAuthStore()
  if (!hydrated) return <HydrationGate />
  return accessToken ? <Navigate to="/events" replace /> : <Outlet />
}

export function SuperAdminRoute() {
  const user = useAuthStore((state) => state.user)
  return user?.roles.some((role) => role.toLowerCase() === 'superadmin') ? <Outlet /> : <Navigate to="/events" replace />
}
